export default __webpack_public_path__ + "static/media/sitelang.918c7647.svg";